import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';

const Column = ({ children, isHeader, className, colspan }) => (
  <>
    {isHeader && (
      <th className={clsx('p-2', className)} colSpan={colspan}>
        {children}
      </th>
    )}
    {!isHeader && (
      <td className={clsx('p-2', className)} colSpan={colspan}>
        {children}
      </td>
    )}
  </>
);

Column.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  isHeader: PropTypes.bool,
  className: PropTypes.string,
  colspan: PropTypes.number,
};

Column.defaultProps = {
  children: <></>,
  isHeader: false,
  className: undefined,
  colspan: undefined,
};

const Row = ({ children, isHeader, isSelected, onClick, highlightOnHover }) => (
  <tr
    className={clsx('flex flex-col sm:table-row', {
      'sm:h-16 border-b-2 cursor-default': !isHeader,
      'bg-theme bg-opacity-10': isSelected,
      'hover:bg-theme hover:bg-opacity-10': highlightOnHover,
    })}
    onClick={onClick}
  >
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { isHeader });
      }
      return child;
    })}
  </tr>
);

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  isHeader: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  highlightOnHover: PropTypes.bool,
};

Row.defaultProps = {
  children: <></>,
  isHeader: false,
  isSelected: false,
  onClick: undefined,
  highlightOnHover: true,
};

const Head = ({ children }) => (
  <thead className="uppercase bg-gray-100 border-b-2 hidden sm:table-header-group">
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { isHeader: true });
      }
      return child;
    })}
  </thead>
);

Head.propTypes = {
  children: PropTypes.node,
};

Head.defaultProps = {
  children: <></>,
};

const Body = ({ children, className }) => <tbody className={className}>{children}</tbody>;

Body.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
};

Body.defaultProps = {
  children: <></>,
  className: '',
};

const Table = ({ children }) => (
  <div className="col-span-3 xl:col-span-2 border-2 sm:text-xs xl:text-sm">
    <table className="table-auto w-full max-w-full text-center">{children}</table>
  </div>
);

Table.propTypes = {
  children: PropTypes.node,
};

Table.defaultProps = {
  children: <></>,
};

Table.Body = Body;
Table.Head = Head;
Table.Row = Row;
Table.Column = Column;

export default Table;
